import React from 'react'
import View from 'components/rollbook'
import './rollbook.styl'

export default function Rollbook() {
    return (<View />)
}
